export enum ColumnOptionsListPage {
  TrucksReport = 'TRUCKS_REPORT',
  ConsolidationsReport = 'CONSOLIDATION_REPORT',
  DriversReport = 'DRIVERS_REPORT',
  ShipmentList = 'SHIPMENT_LIST',
  BulkShipments = 'BULK_SHIPMENTS'
}
